import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@abyss/web/ui/Modal';
import { IconBrand } from '@abyss/web/ui/IconBrand';
import { styled } from '@abyss/web/tools/styled';
import { Layout } from '@abyss/web/ui/Layout';
import { Text } from '@abyss/web/ui/Text';

const StyledModalSectionContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: '$lg',
});

export const ApiErrorModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      css={{
        'abyss-modal-header-container': { marginTop: '$md' },
      }}
      isOpen={isOpen}
      onClose={onClose}
    >
      <StyledModalSectionContainer>
        <Modal.Section>
          <Layout.Stack alignLayout="center" alignItems="center">
            <IconBrand size="58px" icon="alert" brand="uhc" />
            <Text size="$lg" fontWeight="bold">
              The system is unable to respond at the moment.
            </Text>
            <Text>
              Please try refreshing the page or try again at a later time.
            </Text>
          </Layout.Stack>
        </Modal.Section>
      </StyledModalSectionContainer>
    </Modal>
  );
};

ApiErrorModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

ApiErrorModal.defaultProps = {
  isOpen: false,
};
